"use strict";
/**
 * These helpers and enums are ported from @prezly/sdk to avoid leaking the dependency into the client bundle.
 * The types are matching SDK v15.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isScheduledEmbargo = exports.isStoryPublished = exports.FormatVersion = exports.Status = exports.Visibility = void 0;
var Visibility;
(function (Visibility) {
    Visibility["PUBLIC"] = "public";
    Visibility["EMBARGO"] = "embargo";
    Visibility["PRIVATE"] = "private";
    Visibility["CONFIDENTIAL"] = "confidential";
})(Visibility || (exports.Visibility = Visibility = {}));
var Status;
(function (Status) {
    Status["UNINITIALIZED"] = "uninitialized";
    Status["DRAFT"] = "draft";
    Status["SCHEDULED"] = "scheduled";
    Status["EMBARGO"] = "embargo";
    Status["PUBLISHED"] = "published";
})(Status || (exports.Status = Status = {}));
var FormatVersion;
(function (FormatVersion) {
    FormatVersion[FormatVersion["HTML"] = 1] = "HTML";
    FormatVersion[FormatVersion["SLATEJS"] = 3] = "SLATEJS";
})(FormatVersion || (exports.FormatVersion = FormatVersion = {}));
function isStoryPublished(arg) {
    if (typeof arg === 'object' && arg !== null) {
        return isStoryPublished(arg.status);
    }
    return arg === Status.PUBLISHED;
}
exports.isStoryPublished = isStoryPublished;
function isScheduledEmbargo(arg) {
    if (typeof arg === 'object' && arg !== null) {
        return isScheduledEmbargo(arg.status);
    }
    return arg === Status.EMBARGO;
}
exports.isScheduledEmbargo = isScheduledEmbargo;
//# sourceMappingURL=sdkHelpers.js.map